import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { CustomCardFooter } from "../../../../components/Common/CustomCardStyled";

type Props = {
    isCentralizationActive: boolean;
    onCancel: () => void;
    onValidate: () => void;
};

export function FormFooter({
    isCentralizationActive,
    onCancel,
    onValidate,
}: Props) {
    const { t } = useTranslation();

    const validateClassName = `cmn_btn_validate  ${classnames({
        "not-allowed-icon__clz": isCentralizationActive === true,
    })}`;

    return (
        <CustomCardFooter className="pt-1 pb-2 mt-4">
            <CustomSecondaryColorButton
                data-testid="fidelity-information-cancel-button"
                outline
                rounded
                className="mr-2 fed_btn_FRcancel cmn_btn_cancel"
                variant="light"
                onClick={onCancel}
            >
                <span> {t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                data-testid="fidelity-information-validate-button"
                variant="primary"
                className={validateClassName}
                onClick={onValidate}
                rounded
            >
                {t("Validate")}
            </CustomMainColorButton>
        </CustomCardFooter>
    );
}
